(function ($) {

    function luke_dropdown_init() {
        $('.luke-dropdown').on('change', function(e) {
            e.preventDefault();
            var id = $(this).val();
            var selector = '#' + id;
            $('html, body').animate({ 
                scrollTop: $('#' + id).offset().top - 32
            },'slow');
        });
    }

    $(document).ready(function () {
        luke_dropdown_init();
    });

})(jQuery);